import { createActions } from 'redux-actions';

export const {
  //  GET ALL TEMPLATES
  getAllTemplates,
  getAllTemplatesSuccess,
  getAllTemplatesFailure,
  deleteSelectedTemplates,
  deleteSelectedTemplatesSuccess,
  deleteSelectedTemplatesFailure,
} = createActions(
  'GET_ALL_TEMPLATES',
  'GET_ALL_TEMPLATES_SUCCESS',
  'GET_ALL_TEMPLATES_FAILURE',
  'DELETE_SELECTED_TEMPLATES',
  'DELETE_SELECTED_TEMPLATES_SUCCESS',
  'DELETE_SELECTED_TEMPLATES_FAILURE'
);
